import { ContactUsService } from './../service/contact-us.service';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/ui/notification/toast.service';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  providers: [],


})
export class ContactUsComponent implements OnInit {
  @Input() public address: any;
  isDisabled : boolean = false;
  @ViewChild('dangerTpl') dangerTpl: TemplateRef<any> | undefined;

  constructor(
    private ContactUsService: ContactUsService,
    protected activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    protected router: Router,
    private modalService: NgbModal,
    protected titleService: Title,
    private metaService: Meta,
    private responsiveService: ResponsiveService
  ) { }

  ngOnInit(): void {
    const doc = this.responsiveService.getDocument()//TODO: change here
    if(doc && doc.scrollingElement){
      doc.scrollingElement.scrollTop = 0;
    }
    
    this.titleService.setTitle('Contact Us for Professional Property Management Services in Michigan');
    this.metaService.updateTag(
      { name: 'keywords', content: `Professional Property Management, Property Management Services, Property Management Michigan` },
    );
    this.metaService.updateTag(
      { name: 'description', content: `Contact North Bloomfield Properties Management for fine rental homes and professional property management services in the Michigan area.` }
    );

  }

  contactUsForm: FormGroup = this.ContactUsService.getcontactusForm();
  async contactus() {
    if (this.contactUsForm.valid) {
      // console.log('contactus', this.contactUsForm.value);
      this.isDisabled = true;
      this.ContactUsService
        .sendRequest({
          name: this.contactUsForm.value.name,
          contact: this.contactUsForm.value.contact,
          email: this.contactUsForm.value.email,
          comment: this.contactUsForm.value.comment,
        }).toPromise().then(()=>{
          this.isDisabled = false;
          this.router.navigate([`thankYou`]);
        }).catch((err)=>{
          this.showDanger(err.error.error)
          this.isDisabled = false;
        });
    } else {
      // this.showDanger();
      this.contactUsForm.markAllAsTouched();
      const keys = Object.keys(this.contactUsForm.controls);
      for (const key of keys) {
        this.contactUsForm.get(key)?.markAsDirty();
      }
    }
  }
  dimentions: { lat: string, long: string, address:string } | undefined = {
    lat: '42.59221899999999',
    long: '-83.44292999999996',
    address: 'North Bloomfield Properties'
  };
  // showSuccess() {
  //   this.toastService.show('Operation Successful', {
  //     classname: 'bg-success text-light',
  //     delay: 10000,
  //   });
  // }

  showDanger(error:string) {
    // if (!this.dangerTpl) return;
    this.toastService.show(error, { classname: 'bg-danger text-light', delay: 15000 });
  }
}
